export default function getWholeToken() {
    const wholeToken = JSON.parse(localStorage.getItem("token"));

    return { token: wholeToken.token, userId: wholeToken.user_id };
}
